import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

// Shown while a connected account's first Income backfill runs in the
// background worker. `startedAt` is re-read on every sync poll, so the
// "started X ago" line keeps moving without a timer of its own.
const CustomLoader = ({ startedAt }) => {
  const { t } = useTranslation("common");
  return (
    <div className="custom-loader">
      <div className="loader-card">
        <h3>{t("loader.importingTitle")}</h3>
        <p className="p2">
          {t("loader.importingBody")} <br />
          {t("loader.canLeave")}
        </p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          width={100}
          height={100}
          className="filter-none!"
          aria-hidden="true"
        >
          <defs>
            <linearGradient
              id="custom-loader-gradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop offset="0%" stopColor="var(--gradient-left)" />
              <stop offset="100%" stopColor="var(--gradient-right)" />
            </linearGradient>
          </defs>
          {[30, 50, 70].map((cx, i) => (
            <circle
              key={cx}
              fill="url(#custom-loader-gradient)"
              cx={cx}
              cy="50"
              r="6"
            >
              <animate
                attributeName="opacity"
                dur="1s"
                values="0;1;0"
                repeatCount="indefinite"
                begin={`${(i + 1) / 10}`}
              />
            </circle>
          ))}
        </svg>
        {startedAt && (
          <p className="p3 loader-started">
            {t("loader.startedAgo", { time: moment(startedAt).fromNow() })}
          </p>
        )}
      </div>
    </div>
  );
};

export default CustomLoader;
